import tab_a9 from "../../assets/samsung/tab_a9/tab_a9.jpeg";
import tab_a9_graphite from "../../assets/samsung/tab_a9/tab_a9_graphite.jpeg";
import tab_a9_mystic_blue from "../../assets/samsung/tab_a9/tab_a9_mystic_blue.jpeg";
import tab_a9_mystic_grey from "../../assets/samsung/tab_a9/tab_a9_mystic_grey.jpeg";

import tab_s10_plus from "../../assets/samsung/mix/tab_s10_plus.jpeg";
import tab_s10_plus_platinum_silver from "../../assets/samsung/mix/tab_s10_plus_platinum_silver.jpeg";
import tab_s10_plus_moonstone_grey from "../../assets/samsung/mix/tab_s10_plus_moonstone_grey.jpeg";

import tab_s10_fe_plus1 from "../../assets/samsung/tab10Feplus/1.jpeg";
import tab_s10_fe_plus2 from "../../assets/samsung/tab10Feplus/2.jpeg";
import tab_s10_fe_plus3 from "../../assets/samsung/tab10Feplus/3.jpeg";


export const tab = [
  {
    id: 1,
    title: "Galaxy Tab A9",
    productImage: tab_a9,
    images: [tab_a9, tab_a9_graphite, tab_a9_mystic_blue, tab_a9_mystic_grey],
    // originalPrice: '₹ 13,999',
    discountedPrice: "14,999",
    // offerText: 'Flat ₹3,901 off',
    colors: ["Graphite", "Silver", "Navy"],
    offers: [
      // { label: 'Offer', value: 'Get ₹1500 off on Axis Bank Credit Card' },
      // { label: 'EMI', value: 'Available from ₹999/month' },
    ],
    specifications: {
      // Audio: 'Dolby Atmos',
      // Battery: '5000mAh with 25W fast charging',
      // Controls: 'On-screen fingerprint scanner',
      // Compatibility: 'Works with Android 13',
      // Specs: {
      //   Chip: 'Exynos 1380',
      //   Connectivity: '5G, Wi-Fi 5',
      //   Case: 'Supports wireless charging',
      //   Weight: '202g',
      //   WaterResistance: 'IP67',
      //   Warranty: '1 year',
      // },
      Specs: [
        '8.7" inch TFT LCD (800 x 1340) HD+',
        "Max. Refresh Rate = 60 Hz",
        "Powered by MediaTek Helio G99 (6nm)",
        "Up to 6GB RAM & Up to 64GB Storage (Expandable storage support - MicroSD up to 1TB)",
        "Rear Camera - 8 MP autofocus",
        "Front Camera - 2 MP fixed-focus",
        "5100mah",
      ],
    },
  },

  {
    id: 2,
    title: "Galaxy Tab S10 Plus",
    productImage: tab_s10_plus,
    images: [
      tab_s10_plus,
      tab_s10_plus_platinum_silver,
      tab_s10_plus_moonstone_grey,
    ],
    // originalPrice: '₹ 13,999',
    discountedPrice: "1,01,999",
    // offerText: 'Flat ₹3,901 off',
    colors: ["Moonstone Gray", "Platinum Silver"],
    offers: [
      // { label: 'Offer', value: 'Get ₹1500 off on Axis Bank Credit Card' },
      // { label: 'EMI', value: 'Available from ₹999/month' },
    ],
    specifications: {
      // Audio: 'Dolby Atmos',
      // Battery: '5000mAh with 25W fast charging',
      // Controls: 'On-screen fingerprint scanner',
      // Compatibility: 'Works with Android 13',
      // Specs: {
      //   Chip: 'Exynos 1380',
      //   Connectivity: '5G, Wi-Fi 5',
      //   Case: 'Supports wireless charging',
      //   Weight: '202g',
      //   WaterResistance: 'IP67',
      //   Warranty: '1 year',
      // },
      Specs: [
        '12.4" inch - Dynamic AMOLED 2X (2800 x 1752)',
        "Max. Refresh Rate = 120 Hz",
        "Comes with S pen",
        "Connectivity - WI-FI only & LTE + Wi-Fi",
        "Powered by MidiaTek Dimensity 9300",
        "Up to 12GB RAM & Up to 512GB Storage (Expandable storage support - MicroSD up to 1.5TB)",
        "Dual Rear Camera - 13 MP + 8 MP",
        "Front Camera - 12 MP",
        "10,090mah Li-Po battery",
        "IP68 Water resistance",
      ],
    },
  },
  {
    id: 3,
    title: "Galaxy Tab S10 FE Plus",
    productImage: tab_s10_fe_plus3,
    images: [
      tab_s10_fe_plus1,
      tab_s10_fe_plus2,
      tab_s10_fe_plus3,
    ],
    // originalPrice: '₹ 13,999',
    discountedPrice: "64,999",
    // offerText: 'Flat ₹3,901 off',
    colors: ["Moonstone Gray", "Platinum Silver"],
    offers: [
      // { label: 'Offer', value: 'Get ₹1500 off on Axis Bank Credit Card' },
      // { label: 'EMI', value: 'Available from ₹999/month' },
    ],
    specifications: {
      // Audio: 'Dolby Atmos',
      // Battery: '5000mAh with 25W fast charging',
      // Controls: 'On-screen fingerprint scanner',
      // Compatibility: 'Works with Android 13',
      // Specs: {
      //   Chip: 'Exynos 1380',
      //   Connectivity: '5G, Wi-Fi 5',
      //   Case: 'Supports wireless charging',
      //   Weight: '202g',
      //   WaterResistance: 'IP67',
      //   Warranty: '1 year',
      // },
      Specs: [
        '123.1"inch - Super PLS LCD (1800 x 2880)',
        "Max. Refresh Rate = 90 Hz",
        "Comes with S pen",
        "Connectivity - WI-FI only & LTE + Wi-Fi",
        "Powered by Exynos 1580 (4nm)",
        "Up to 12GB RAM & Up to 256GB Storage (Expandable storage support - MicroSD up to 2TB)",
        "Single Rear Camera - 13 MP sensor",
        "Front Camera - 12 MP selfie cam with 4K support and HDR capabilities",
        "10,090mah Li-Po battery. Supports 45 W fast charging",
        "IP68 Water resistance",
      ],
    },
  },
];
